import { EMPTY_FIELD } from 'constants/emptyField';

import { GatewayRuleMappingDescriptionEditDialog } from 'pages/GatewayRules/components/GatewayRuleMappingDescriptionDialog/GatewayRuleMappingDescriptionEditDialog';
import { GatewayRuleMappingDescriptionShowDialog } from 'pages/GatewayRules/components/GatewayRuleMappingDescriptionDialog/GatewayRuleMappingDescriptionShowDialog';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Link } from 'shared/mui/Link/Link';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { Mapping } from 'types/embedded/gatewayRule';

import {
  StyledDescriptionContainer,
  StyledDescriptionTextField,
} from './GatewayRuleMappingInfo.styled';
import { useMappingDescription } from './hooks/useMappingDescription';

export const GatewayRuleMappingDescriptionField: React.FC = () => {
  const translate = useTypedTranslate();
  const mappingRecord = useRecordContext<Mapping>();

  const {
    showDescription,
    editDescription,
    setShowDescription,
    setEditDescription,
    handleSubmitDescription,
  } = useMappingDescription();

  return (
    <>
      <StyledDescriptionContainer>
        <Typography component="span" mr={1} variant="subtitle2">
          {`${translate('app.table.description')}:`}
        </Typography>
        <StyledDescriptionTextField emptyText={EMPTY_FIELD} mr={1} source="description" />
        <FunctionField
          render={(record: Mapping) => {
            if (!record.description) {
              return <></>;
            }
            return (
              <>
                <span>(</span>
                <Typography
                  component={Link}
                  fontWeight={400}
                  onClick={() => setShowDescription(true)}
                  sx={{ cursor: 'pointer' }}
                  variant="subtitle2"
                >
                  {`${translate('app.common.view')}:`}
                </Typography>
                <span>)</span>
              </>
            );
          }}
        />
      </StyledDescriptionContainer>
      {showDescription && mappingRecord && (
        <GatewayRuleMappingDescriptionShowDialog
          mapping={mappingRecord}
          onClose={() => setShowDescription(false)}
          onSubmitDialog={() => setEditDescription(true)}
          open={showDescription}
        />
      )}
      {editDescription && mappingRecord && (
        <GatewayRuleMappingDescriptionEditDialog
          mapping={mappingRecord}
          methodName={mappingRecord.method?.name}
          onClose={() => setEditDescription(false)}
          onSubmitDialog={handleSubmitDescription}
          open={editDescription}
        />
      )}
    </>
  );
};
